import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          热门话题标签
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          全网最热影视话题，看看大家都在追什么
        </p>
        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topics.map((topic) => (
            <span
              key={topic.label}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium cursor-pointer transition-colors ${
                topic.hot
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50 text-foreground-700 hover:bg-secondary-100 border border-background-200/60'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-xs"></i>}
              <span>{topic.label}</span>
              <span className={`text-xs ${topic.hot ? 'text-background-50/70' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}